import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { formatACFT, formatNumber } from '../../dwriUtils';

const DwriPeakDaySection = ({ peakDayData, loading, error }) => {
    if (error) return <p className="text-danger">Error loading peak day data.</p>;
    if (loading && peakDayData.length === 0) return <p>Loading...</p>;

    const sorted = [...peakDayData].sort((a, b) => b.historyYear - a.historyYear);

    return (
        <>
            <Row>
                <Col><span><b>Peak Day (ACFT)</b></span></Col>
            </Row>
            <div className="table-responsive">
                <Row className='dwri-peak-day-acft-header gx-0'>
                    <Col className='dwri-table-header-cell'><span><b>Year</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Measure Type</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Date</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Amount</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Includes: In/Out</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Wholesale: Y/N</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Wholesale Amount</b></span></Col>
                </Row>
                {sorted.map((peak, index) => (
                    <Row key={index} className={`dwri-peak-day-acft-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}>
                        <Col className='dwri-table-cell'><span>{peak.historyYear}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.peakMeasurementType}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.peakDate}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(peak.peakDemandACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.peakUseInclude}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.peakWholesaleVolumeACFT > 0 ? 'Y' : 'N'}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(peak.peakWholesaleVolumeACFT)}</span></Col>
                    </Row>
                ))}
            </div>
            <br />

            <Row>
                <Col><span><b>Peak Day (Gal)</b></span></Col>
            </Row>
            <div className="table-responsive">
                <Row className='dwri-peak-day-gal-header gx-0'>
                    <Col className='dwri-table-header-cell'><span><b>Year</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Date</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Amount</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Includes: In/Out</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Wholesale: Y/N</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Wholesale Amount</b></span></Col>
                </Row>
                {sorted.map((peak, index) => (
                    <Row key={index} className={`dwri-peak-day-gal-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}>
                        <Col className='dwri-table-cell'><span>{peak.historyYear}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.peakDate}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatNumber(peak.peakDemandGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.peakUseInclude}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.peakWholesaleVolumeACFT > 0 ? 'Y' : 'N'}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatNumber(peak.peakWholesaleVolumeGallons)}</span></Col>
                    </Row>
                ))}
            </div>
            <br />
        </>
    );
};

export default DwriPeakDaySection;
